<template>
  <v-form ref="translationForm" @submit.prevent="">
    <v-row>
      <!-- language -->
      <v-col class="col-6 offset-6 pb-0">
        <v-select
          v-model="currentLanguage"
          outlined
          :items="$store.getters.getLanguages()"
          :label="$t('layout.selectLanguage')"
          item-value="value"
          item-text="text"
        />
      </v-col>
    </v-row>

    <v-row v-if="currentLanguage">
      <!-- title -->
      <v-col v-if="!hideTitle" class="col-12 pb-0">
        <v-text-field
          v-model="
            entityTranslations.getTranslationByLanguageValue(
              currentLanguage,
              true
            ).title
          "
          outlined
          :label="$t('singleEventView.eventTitle')"
          :rules="[(v) => !!v || $t('singleEventView.eventTitleRequired')]"
        />
      </v-col>

      <!-- lead -->
      <v-col class="col-12" :class="[hideTitle ? 'pb-0' : 'py-0']">
        <v-textarea
          v-model="
            entityTranslations.getTranslationByLanguageValue(
              currentLanguage,
              true
            ).mediumText
          "
          outlined
          :rows="2"
          :label="$t('singleEventView.eventLead')"
          :counter="255"
          :rules="[
            (v) =>
              (!!v && v.length < 256) ||
              $t('singleEventView.eventLeadRequired'),
          ]"
        />
      </v-col>

      <!-- icons -->
      <v-col class="col-12" :class="[hideTitle ? 'pb-0' : 'py-0']">
        <translation-icons
          :entity-translations="entityTranslations"
          :current-language="currentLanguage"
        />
      </v-col>

      <!-- description -->
      <v-col class="col-12 pt-6">
        {{ $t('singleEventView.eventDescription') }}
      </v-col>
      <v-col class="col-12 pt-0">
        <s-text-editor ref="textEditor" @update:content="updateLongText" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import EntityTranslations from '../../classes-shared/entityTranslations/EntityTranslations'
import STextEditor from '../../components-shared/utils/STextEditor'
import SFontAwesomeSelect from '../../components-shared/utils/SFontAwesomeSelector'
import TranslationIcons from './TranslationIcons'

export default {
  name: 'TranslationsForm',
  components: { TranslationIcons, STextEditor },
  props: {
    // class instance, where all the translations live
    entityTranslations: {
      type: EntityTranslations,
      required: true,
    },

    hideTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      currentLanguage: null,
    }
  },

  computed: {
    longText() {
      return this.entityTranslations.getTranslationByLanguageValue(
        this.currentLanguage,
        true
      ).longText
    },
  },

  watch: {
    // manually set long text
    currentLanguage() {
      this.setLongText()
    },
  },

  mounted() {
    // set current language
    this.currentLanguage = this.$store.getters.getActualLanguage(false)
    this.setLongText()
  },

  methods: {
    // validate the form. Used by parent components
    validate() {
      return this.$refs.translationForm.validate()
    },

    updateLongText(content) {
      this.entityTranslations.getTranslationByLanguageValue(
        this.currentLanguage,
        true
      ).longText = content
    },

    setLongText() {
      this.$nextTick(() => {
        this.$refs.textEditor.setContent(this.longText)
      })
    },
  },
}
</script>
